const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/appointmentConfirmation.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import moment from 'moment/moment';
import { KISIM_STD_DATE_TIME_FORMAT, KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';

export const LOAD_APPOINTMENT_CONFIRMATIONS = kisapiActionTypes('PATAPP_LOAD_APPOINTMENT_CONFIRMATIONS');
export const CREATE_APPOINTMENT_CONFIRMATION = kisapiActionTypes('PATAPP_CREATE_APPOINTMENT_CONFIRMATION');

export function actionLoadAppointmentConfirmations() {
    const endpoint = `/appointmentConfirmations`;
    const meta = { suppressErrorMsg: true };
    return createPatapiCall(LOAD_APPOINTMENT_CONFIRMATIONS, endpoint, HttpMethod.GET, meta);
}

export function confirmAppointment(appointment: StructuredAppointment) {
    const termNr = appointment.TERMNR;

    const endpoint = `/appointments/id/${termNr}/confirm`;

    const meta = { suppressErrorMsg: true, appointment };

    const body = {
        subject: `OP Eintrittszeit Bestätigung vom ${moment(appointment.STARTDAT, KISIM_TIME_FORMAT).format(
            KISIM_STD_DATE_TIME_FORMAT
        )}`,
    };

    return createPatapiCall(CREATE_APPOINTMENT_CONFIRMATION, endpoint, HttpMethod.POST, meta, JSON.stringify(body));
}
